import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Card, Modal, Input, message, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { setBreadcrumbList } from "../../../store/menuInfo/menuInfo";
import apis from "../../../apis";
import "./index.scss";

const { TextArea } = Input;

const AuditDetail = ({ id, mode = "view", onBack }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});
  const [rejectVisible, setRejectVisible] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setBreadcrumbList([
        { title: "充值方案" },
        { title: "TOC方案审核", onClick: onBack },
        { title: "审核详情" },
      ])
    );
  }, [dispatch, onBack]);

  useEffect(() => {
    if (id) {
      setLoading(true);
      apis
        .getTocTopupAuditDetail({ topup_plan_audit_id: id })
        .then((res) => {
          if (res.code === 200) {
            setDetail(res.data || {});
          } else {
            message.error(res.message || "获取详情失败");
          }
        })
        .catch(() => {
          message.error("获取详情失败");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  const handleApprove = () => {
    Modal.confirm({
      title: "确认通过",
      content: "确定要通过该审核吗？",
      onOk: () => {
        return apis
          .approveTocTopupAudit({
            topup_plan_audit_id: id,
            comment: "审核通过",
          })
          .then((res) => {
            if (res.code === 200) {
              message.success("操作成功");
              onBack();
            } else {
              message.error(res.message || "操作失败");
            }
          })
          .catch(() => {
            message.error("操作失败");
          });
      },
    });
  };

  const handleReject = () => {
    if (!rejectReason || !rejectReason.trim()) {
      message.warning("请输入驳回原因");
      return;
    }
    apis
      .rejectTocTopupAudit({
        topup_plan_audit_id: id,
        comment: rejectReason,
      })
      .then((res) => {
        if (res.code === 200) {
          message.success("操作成功");
          setRejectVisible(false);
          onBack();
        } else {
          message.error(res.message || "操作失败");
        }
      })
      .catch(() => {
        message.error("操作失败");
      });
  };

  const getPlanTypeText = (code) => {
    if (code === "PERSONAL" || code === "PERSONAL_EDITION") return "个人版";
    if (code === "SEAT" || code === "ENTERPRISE_EDITION") return "企业版";
    return code || "-";
  };

  const { plan = {}, version = {}, audit = {}, flow_logs = [] } = detail;

  const isApproved = audit?.audit_result_code === 'APPROVED';

  return (
    <div className="toc-audit-detail-container">
      <Spin spinning={loading}>
        <div className="content-body">
          <Card bordered={false} style={{ position: 'relative' }}>
            <div className="itemTitle2">
              <span>
                01<i></i>
              </span>
              基本信息
            </div>

            <Form
              layout="horizontal"
              labelCol={{ flex: "90px" }}
              wrapperCol={{ flex: "auto" }}
              labelAlign="left"
              colon={false}
            >
              <div className="subscriptionItemsContent">
                <Form.Item label="产品">
                  <span className="view-text">
                    {plan.prd_name || plan.prd_id || "-"}
                  </span>
                </Form.Item>
                <Form.Item label="方案类别" required>
                  <span className="view-text">
                    {getPlanTypeText(plan.topup_plan_type_code)}
                  </span>
                </Form.Item>
                <Form.Item label="方案编码" required>
                  <span className="view-text">{plan.topup_plan_code || "-"}</span>
                </Form.Item>
                <Form.Item label="方案名称" required>
                  <span className="view-text">{version.topup_plan_name || "-"}</span>
                </Form.Item>
                <Form.Item label="积分" required>
                  <span className="view-text">{version.credits ?? "-"}</span>
                </Form.Item>
                <Form.Item label="原价 (元)" required>
                  <span className="view-text">
                    {version.original_price !== undefined && version.original_price !== null
                      ? `¥${Number(version.original_price).toFixed(2)}`
                      : "-"}
                  </span>
                </Form.Item>
                <Form.Item label="折扣价 (元)" required>
                  <span className="view-text">
                    {version.discount_price !== undefined && version.discount_price !== null && version.discount_price !== ""
                      ? `¥${Number(version.discount_price).toFixed(2)}`
                      : "-"}
                  </span>
                </Form.Item>
                <Form.Item
                  label="方案描述"
                  className="full-width"
                  labelCol={{ flex: "90px" }}
                  wrapperCol={{ flex: "auto" }}
                >
                  <span className="view-text">
                    {version.topup_plan_desc || "-"}
                  </span>
                </Form.Item>
              </div>
            </Form>

            <div className="itemTitle2" style={{ marginTop: "24px" }}>
              <span>
                02<i></i>
              </span>
              流程
            </div>

            <div className="process-list">
              <div className="process-header-line"></div>
              {flow_logs.map((item, index) => {
                let statusText = "";
                if (item.processing_type_code === "SUBMIT")
                  statusText = "提交审核";
                else if (item.processing_type_code === "APPROVE")
                  statusText = "审核通过";
                else if (item.processing_type_code === "REJECT")
                  statusText = "审核驳回";
                else statusText = item.processing_type_code;

                return (
                  <div
                    className="process-item"
                    key={item.topup_plan_audit_flow_id || index}
                  >
                    <div className="step-name">{statusText}</div>
                    <div className="user-info">
                      <Avatar
                        size={24}
                        src={item.processor_photo}
                        icon={<UserOutlined />}
                        style={{ marginRight: 8 }}
                      />
                      <span className="name">
                        {item.processor_name || "System"}
                      </span>
                    </div>
                    <div className="time">{item.processing_time || "-"}</div>
                    <div className="remark">{item.comment || ""}</div>
                  </div>
                );
              })}
            </div>
          </Card>
        </div>

        <div className="footer-actions">
          {mode === "audit" ? (
            <div style={{ display: "flex", gap: "20px" }}>
              <Button onClick={onBack} style={{ width: "120px" }}>
                取消
              </Button>
              <Button
                danger
                onClick={() => setRejectVisible(true)}
                style={{ width: "120px" }}
              >
                驳回
              </Button>
              <Button
                type="primary"
                onClick={handleApprove}
                style={{ width: "120px" }}
              >
                同意
              </Button>
            </div>
          ) : (
            <Button onClick={onBack} style={{ width: "120px" }}>
              关闭
            </Button>
          )}
        </div>
      </Spin>

      <Modal
        title="驳回审核"
        open={rejectVisible}
        onOk={handleReject}
        onCancel={() => setRejectVisible(false)}
      >
        <TextArea
          rows={4}
          placeholder="请输入驳回原因"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default AuditDetail;
